import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import {
  downloadList,
  downloadListCount,
  clearDownloadList,
} from 'gatsby-theme-kn/src/utils/media_database_download_list'
import MediaDatabaseDownloadListItem from 'gatsby-theme-kn/src/components/technical/MediaDatabaseDownloadListItem'
import ModalModule from 'gatsby-theme-kn/src/components/modules/ModalModule'
import useModal from 'gatsby-theme-kn/src/hooks/useModal'
import ModalMediaDatabaseDownloadList from 'gatsby-theme-kn/src/components/modules/ModalMediaDatabaseDownloadList'

const MediaDatabaseDownloadListShow = ({ params }) => {
  const { t } = useTranslation()
  const [isOpen, setIsOpen] = useState(false)

  // Modal: Download-List
  const [modalState, setModalState] = useState(false)
  const [downloadListId, setDownloadListId] = useState(false)

  const openModal = () => {
    setModalState(true)
  }
  const closeModal = () => {
    setModalState(false)
  }

  useEffect(() => {
    if (params['download_list']) {
      setDownloadListId(params['download_list'])
      setModalState(true)
    }
  }, [params])

  return (
    <>
      <ModalModule
        isOpen={modalState}
        closeModal={closeModal}
        title={t('generic.spa.media.index.download_list')}
      >
        <ModalMediaDatabaseDownloadList downloadListId={downloadListId} />
      </ModalModule>
    </>
  )
}

export default MediaDatabaseDownloadListShow
